module.exports = __webpack_public_path__ + "b9098d922d7fa445449ca70446a9fbf8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/necklace-flowers-s.png
// module id = 1937
// module chunks = 0